/*
Item: Form to xxx
Name: xxx
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { RadioButton } from 'primereact/radiobutton';
import { Card } from 'primereact/card';
import MessageService from '../service/MessageService';
import { MultiLanguage } from '../utils/MultiLanguage';

export default class Evaluation extends Component {
  constructor() {
    super();
    this.state = {
      // maxRowsPerPage: 300,
      selected: [],
      selected1: [],
      buttonDisabled: true,
      regional: '',
      group: sessionStorage.getItem('group'),
    };
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
  }

  // onLoad read current data
  componentDidMount = async () => {
    const { group } = this.state;
    if (group === 'StBA') {
      // this.state.regional = "Bund";
      this.setState({ regional: 'Bund' });
    }
    this.loadStatisticList();
  };

  /*
  async handleClick1(i) {
    const tmp = [...this.state.selected];
    if (tmp[i] === undefined) tmp[i] = false;
    tmp[i] = !tmp[i];
    let buttonDisabled = !tmp.includes(true) || this.state.regional === '';
    this.setState({
      selected: tmp,
      buttonDisabled,
    });
  }
  */

  async handleClick(i, name) {
    const { selected, selected1, regional } = this.state;
    const arrSelected = [...selected];
    if (arrSelected[i] === undefined) arrSelected[i] = false;
    arrSelected[i] = !arrSelected[i];
    const arrSelected1 = [...selected1];
    if (arrSelected1[i] === undefined || arrSelected1[i] === '') {
      arrSelected1[i] = name;
    } else {
      arrSelected1[i] = '';
    }
    const buttonDisabled = !arrSelected.includes(true) || regional === '';
    this.setState({
      selected: arrSelected,
      selected1: arrSelected1,
      buttonDisabled,
    });
  }

  handleChange(regional) {
    let tmp = [...this.state.selected];
    let buttonDisabled = !tmp.includes(true) || regional === '';
    this.setState({
      regional,
      buttonDisabled,
    });
  }

  async loadStatisticList(returnMessage) {
    const statisticsList = await this.messageService.postStatisticDirectory(returnMessage);
    this.setState({
      statisticsList,
    });
  }

  launchStatistics() {
    const { selected1, regional } = this.state;
    sessionStorage.setItem('evaluationStatistics', this.cleanArray(selected1));
    sessionStorage.setItem('evaluationRegional', regional);
    this.props.history.push({
      pathname: './evaluation/statistics',
    });
  }

  cleanArray(actual) {
    const newArray = []; // new Array();
    for (let i = 0; i < actual.length; i += 1) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  renderMetaDataContent(statisticsList) {
    const { selected } = this.state;
    if (statisticsList) {
      return (
        statisticsList.length === 0 || statisticsList[1] === 'info'
          ? (
            <div>
              <Panel style={{ backgroundColor: '#F44336', color: 'white' }}>
                Es konnten keine Statistiken geladen werden.
              </Panel>
            </div>
          )
          : (
            <div>
              <div>
                <div className="p-grid dashboard">
                  {statisticsList.map((s, i) => (
                    <div id={s.name} key={i} className="p-col-12 p-md-4" onClick={() => this.handleClick(i, s.name)}>
                      <div className={selected[i] === true ? 'overview-box overview-box-3' : 'overview-box overview-box-4'}>
                        <div className="overview-box-header" />
                        <div className="overview-box-content">
                          <div className="overview-box-icon"><i className="material-icons">assessment</i></div>
                          <div className="overview-box-title">{s.name}</div>
                          <div className="overview-box-count">{this.multiLanguage.returnInLanguage(s, 'de')}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
      );
    } else {
      return <div />;
    }
  }

  render() {
    const {
      group, statisticsList, regional, buttonDisabled,
    } = this.state;
    return (
      <div className="p-col-12 p-lg-12">
        <h2>Übergreifende und individuelle Auswertungen</h2>
        <p>
          Bitte wählen Sie Statistiken, für die Sie eine flexible Auswertung durchführen wollen.
          <br />
          Für eine Querschnittsauswertung ist die Auswahl mehrerer Statistiken möglich.
        </p>
        <div className="p-grid dashboard">
          <div className="p-col">
            {this.renderMetaDataContent(statisticsList)}
          </div>
        </div>
        <Card>
          <div className="p-grid dashboard">

            <div className="p-col-12 p-md-4" />
            <div className="p-col-12 p-md-2">
              Regionalauswahl:
            </div>
            <div className="p-col-12 p-md-1">
              <RadioButton inputId="rb1" name="regional" value="Bund" onChange={(e) => this.handleChange(e.value)} checked={regional === 'Bund'} />
              <label htmlFor="rb1" className="p-radiobutton-label">Bund</label>
            </div>
            <div className="p-col-12 p-md-2">
              <RadioButton disabled={group === 'StBA'} inputId="rb2" name="regional" value="Land" onChange={(e) => this.handleChange(e.value)} checked={regional === 'Land'} />
              {
                group === 'StBA'
                  ? <label style={{ color: '#CECECE' }} htmlFor="rb2" className="p-radiobutton-label">Land (nur für Landesämter)</label>
                  : <label htmlFor="rb2" className="p-radiobutton-label">Land</label>
              }
            </div>
            <div className="p-col-12 p-md-3" />
          </div>

          <div style={{ textAlign: 'center' }}>
            <Button className="p-button-success" id="tool" icon="pi pi-md-keyboard-arrow-right" onClick={(e) => this.launchStatistics(e.value)} disabled={buttonDisabled} label="Auswertungstool öffnen" />
          </div>
        </Card>
      </div>
    );
  }
}
